import React from "react";
import { FormattedMessage } from "react-intl-phraseapp";
import { SearchResultPlan } from "../../@types";
import { makePlanLongId, sendTealiumEvent } from "../../helpers";
import { ActionsBar } from "../../components";
import routes from "../../app/routes";
import URI from "urijs";

export const BackLinkAndPrint: React.FunctionComponent<{
  search: string;
  goBackTextId: string;
  compareList: SearchResultPlan[];
}> = ({ search, goBackTextId, compareList }) => {
  const cameFromCompare = (goBackTextId: string): boolean => {
    return (
      goBackTextId === "app.terms.go_back_to_plan_compare" &&
      !!compareList.length
    );
  };

  const goBackUrl = (goBackTextId: string): string => {
    if (cameFromCompare(goBackTextId)) {
      const compareURI = new URI(routes.comparePlans);
      compareURI.addSearch(
        "plans",
        compareList.map(plan => makePlanLongId(plan))
      );
      return compareURI.toString();
    } else {
      return `${routes.searchResults}${search}`;
    }
  };

  return (
    <ActionsBar
      to={goBackUrl(goBackTextId)}
      onClick={() => {
        if (cameFromCompare(goBackTextId)) {
          sendTealiumEvent("Plan Details", "Back to Plan Compare");
        } else {
          sendTealiumEvent("Plan Details", "Back to Search Results");
        }
      }}
      printEventAction="Plan Details"
      printClassName="ds-u-display--block ds-u-sm-display--none"
      withPrint
    >
      {goBackTextId && <FormattedMessage id={goBackTextId} />}
    </ActionsBar>
  );
};
